import React, { Component } from 'react'

export default class ErrorResult extends Component {
  render() {
    return (
      <div>ErrorResult</div>
    )
  }
}
